var map = {
	"./dangerPhoto.js": 61549,
	"./dangerType.js": 80809,
	"./inspectionDanger.js": 92861,
	"./record.js": 28735,
	"./rectifiendPhoto.js": 18847,
	"./task.js": 38427,
	"./taskType.js": 9472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84352;